module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "create_customer"
    }
  }, [(!_vm.selectCustomer) ? _c('router-link', {
    staticClass: "ls-btn ls-btn-primary ls-xs-margin-top",
    attrs: {
      "to": {
        name: 'new_customer',
        params: {
          createByContract: true
        }
      }
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "ls-xs-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('customers.new.new_customer')))])]) : _vm._e()], 1), _vm._v(" "), _c('form', {
    staticClass: "ls-form",
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
      },
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-6 col-sm-12 col-xs-12 ls-no-padding"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('contracts.new.new_contract_message')))]), _vm._v(" "), _c('fieldset', [_c('label', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('contracts.customer'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.new.select_customer')))]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "name",
      "id": "customerSearch",
      "transition": "none",
      "data-vv-name": _vm.$t('contracts.customer'),
      "placeholder": _vm.$t('contracts.placeholder.search_by_customer_name'),
      "options": _vm.customerOptions,
      "value": _vm.selectCustomer
    },
    on: {
      "search": _vm.onSearchCustomer,
      "update:value": function($event) {
        _vm.selectCustomer = $event
      }
    },
    nativeOn: {
      "input": function($event) {
        _vm.clearFilter($event)
      }
    },
    model: {
      value: (_vm.selectCustomer),
      callback: function($$v) {
        _vm.selectCustomer = $$v
      },
      expression: "selectCustomer"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(_vm._s(_vm.$t('contracts.new.find_customer')))])], 2), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('contracts.customer'))),
      expression: "errors.has($t('contracts.customer'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('contracts.customer'))))])], 1)]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "create_customer"
    }
  }, [(!_vm.selectCustomer) ? _c('div', [_c('router-link', {
    staticClass: "ls-btn ls-btn-primary ls-xs-margin-bottom ls-xs-margin-top",
    attrs: {
      "to": {
        name: 'new_customer',
        params: {
          createByContract: true
        }
      }
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "ls-xs-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('customers.new.new_customer')))])])], 1) : _vm._e()])], 1), _vm._v(" "), (_vm.selectCustomer) ? _c('div', {
    staticClass: "col-md-7 col-lg-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.new.customer_data')))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-wrap ls-box-filter"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.email')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(_vm.selectCustomer.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.name')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(_vm.selectCustomer.name))])])])]), _vm._v(" "), (_vm.selectCustomer.cpf) ? _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.cpf')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(this.formatCPF(_vm.selectCustomer.cpf)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectCustomer.cnpj) ? _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.cnpj')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(this.formatCNPJ(_vm.selectCustomer.cnpj)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectCustomer.cnpj) ? _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.cnpj')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(this.selectCustomer.trade_name))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectCustomer.kind === 'P') ? _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.type')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.new.people')))])])])]) : _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.type')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.new.enterprise')))])])])]), _vm._v(" "), (_vm.selectCustomer.address) ? _c('div', {
    staticClass: "ls-no-padding col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.selectCustomer.address.postal_code) ? _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.postal_code')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(this.formatCep(_vm.selectCustomer.address.postal_code)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectCustomer.address.street) ? _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.street')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(_vm.selectCustomer.address.street))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectCustomer.address.number) ? _c('div', {
    staticClass: "col-md-6 col-sm-12 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.number')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(_vm.selectCustomer.address.number))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectCustomer.address.neighborhood) ? _c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-6"
  }, [_c('label', {
    staticClass: "ls-label d-flex align-items-center"
  }, [_c('b', {
    staticClass: "ls-label-text ls-sm-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('customers.attributes.address.neighborhood')) + ": "), _c('span', {
    staticClass: "span-text"
  }, [_vm._v(_vm._s(_vm.selectCustomer.address.neighborhood))])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-8 col-md-4 col-lg-offset-9 col-lg-3 col-xs-offset-8 col-sm-offset-6 col-xs-4 col-sm-6 ls-float-right"
  }, [_c('router-link', {
    staticClass: "ls-btn ls-no-margin ls-float-right",
    attrs: {
      "to": {
        name: 'edit_customer',
        params: {
          id: _vm.selectCustomer.value || _vm.selectCustomer.id,
          updateByContract: true
        }
      }
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('customers.main.edit')))])])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ls-float-right col-md-12 col-xs-12 col-sm-12 ls-no-padding-left"
  }, [_c('div', {
    class: ['ls-collapse', _vm.showCollapse ? 'ls-collapse-opened' : ''],
    attrs: {
      "data-ls-module": "collapse"
    }
  }, [_c('div', {
    staticClass: "ls-collapse-header",
    on: {
      "click": function($event) {
        _vm.toogleCollapse()
      }
    }
  }, [_c('h4', {
    staticClass: "ls-collapse-title"
  }, [_vm._v(_vm._s(_vm.$t('contracts.labels.contract_settings')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-collapse-body",
    attrs: {
      "id": "30"
    }
  }, [_c('div', {
    staticClass: "row d-flex flex-wrap"
  }, [_c('div', {
    staticClass: "col-xlg-2 col-xs-12 col-lg-3 ls-no-padding-right"
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('b', {
    staticClass: "ls-label-text ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.settings.days_to_overdue_invoice')) + "\n                    "), _c('popover', {
    attrs: {
      "position": 'right'
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('contracts.new.popover.days_to_overdue_invoice')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-3 col-lg-3 col-xs-2 ls-no-padding"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.days_to_overdue_invoice.value),
      expression: "settings.days_to_overdue_invoice.value"
    }],
    staticClass: "ls-field-sm",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.settings.days_to_overdue_invoice.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.days_to_overdue_invoice.value = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-2 col-lg-3 col-xs-12"
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('b', {
    staticClass: "ls-label-text ls-xs-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.url_notification')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.urlNotification),
      expression: "urlNotification"
    }],
    staticClass: "ls-field-sm",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('contracts.placeholder.url_notification')
    },
    domProps: {
      "value": (_vm.urlNotification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.urlNotification = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-2 col-lg-3 col-xs-12 ls-no-padding ls-display-flex align-items-center"
  }, [_c('label', {
    staticClass: "ls-label col-xlg-12 ls-display-flex align-itens-end ls-no-margin ls-sm-margin-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.generate_service_tax_invoices.value),
      expression: "settings.generate_service_tax_invoices.value"
    }],
    staticClass: "ls-float-left",
    attrs: {
      "type": "checkbox",
      "name": "settings.generate_service_tax_invoices.value"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.generate_service_tax_invoices.value) ? _vm._i(_vm.settings.generate_service_tax_invoices.value, null) > -1 : (_vm.settings.generate_service_tax_invoices.value)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.generate_service_tax_invoices.value,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.generate_service_tax_invoices.value = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.generate_service_tax_invoices.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.generate_service_tax_invoices.value = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ls-display-flex ls-no-margin"
  }, [_c('span', {
    staticClass: "txt-check"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.settings.generate_service_tax_invoices')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-2 col-lg-3 col-xs-12 ls-no-padding ls-display-flex align-items-center"
  }, [_c('label', {
    staticClass: "ls-label col-xlg-12 ls-display-flex align-itens-end ls-no-margin ls-sm-margin-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postPaid),
      expression: "postPaid"
    }],
    staticClass: "ls-float-left",
    attrs: {
      "type": "checkbox",
      "name": "postPaid"
    },
    domProps: {
      "checked": Array.isArray(_vm.postPaid) ? _vm._i(_vm.postPaid, null) > -1 : (_vm.postPaid)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.postPaid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.postPaid = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.postPaid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postPaid = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ls-display-flex ls-no-margin"
  }, [_c('span', {
    staticClass: "txt-check"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.post_paid')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xlg-3 col-lg-offset-9 col-lg-3 col-xs-12 justify-content-flex-end ls-display-flex align-itens-center ls-xs-margin-top-in-sm"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "create_contract_tax"
    }
  }, [_c('button', {
    staticClass: "ls-btn ls-btn-primary ls-no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openTaxesModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('contracts.new.include_taxes')))])])])], 1)])])])])]), _vm._v(" "), (_vm.selectPlan.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 ls-display-flex justify-content-flex-end"
  }, [_c('button', {
    staticClass: "ls-btn ls-btn-primary ls-no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addPlan($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('application.button.add_plan')))])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.plansQuantity), function(index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 col-xs-12 col-md-12 ls-box-filter"
    }, [_c('fieldset', [_c('div', {
      attrs: {
        "data-vv-scope": index
      }
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('contracts.plan'))
      }
    }, [_c('b', {
      staticClass: "ls-label-text"
    }, [_vm._v(_vm._s(_vm.$t('contracts.new.select_plan')))]), _vm._v(" "), _c('v-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      ref: index,
      refInFor: true,
      staticClass: "ls-sm-margin-bottom",
      attrs: {
        "closeOnSelect": "true",
        "label": "name",
        "transition": "none",
        "data-vv-scope": index,
        "placeholder": _vm.$t('contracts.placeholder.search_by_plan_name'),
        "options": _vm.plansOptions,
        "value": _vm.selectPlan[(index - 1)]
      },
      on: {
        "search": _vm.onSearchPlan,
        "update:value": function($event) {
          var $$exp = _vm.selectPlan,
            $$idx = (index - 1);
          if (!Array.isArray($$exp)) {
            _vm.selectPlan[(index - 1)] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      },
      nativeOn: {
        "input": function($event) {
          _vm.clearFilter($event)
        }
      },
      model: {
        value: (_vm.selectPlan[(index - 1)]),
        callback: function($$v) {
          var $$exp = _vm.selectPlan,
            $$idx = (index - 1);
          if (!Array.isArray($$exp)) {
            _vm.selectPlan[(index - 1)] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "selectPlan[(index - 1)]"
      }
    }, [_c('template', {
      slot: "no-options"
    }, [_vm._v(_vm._s(_vm.$t('contracts.new.find_plan')))])], 2), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('contracts.plan'))),
        expression: "errors.has(index.toString() + '.' + $t('contracts.plan'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('contracts.plan'))))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [((index - 1) !== 0) ? _c('div', {
      staticClass: "col-md-12 col-sm-12 col-xs-12"
    }, [_c('button', {
      staticClass: "ls-btn ls-btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removePlan(index - 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  " + _vm._s(_vm.$t('application.button.remove_plan')))])]) : _vm._e()]), _vm._v(" "), (_vm.selectPlan[(index - 1)]) ? _c('div', {
      staticClass: "container-fluid"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "flex-wrap"
    }, [_c('div', {
      staticClass: "col-xlg-1 ls-no-padding col-lg-1-5 col-sm-12 col-xs-6"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.periodicity'))
      }
    }, [_c('span', {
      staticClass: "ls-label-text col-xs-12 ls-sm-margin-bottom ls-no-padding"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('contracts.new.periodicity')) + "\n                      "), _c('popover', {
      attrs: {
        "position": 'right'
      }
    }, [_c('div', {
      slot: "content"
    }, [_vm._v(_vm._s(_vm.$t('contracts.labels.periodicity')))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-5 col-xs-4 col-lg-5 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectPlan[(index - 1)].periodicity),
        expression: "selectPlan[(index - 1)].periodicity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|decimal:0|min_value:1'),
        expression: "'required|decimal:0|min_value:1'"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "step": "1",
        "required": "",
        "name": "plans.attributes.periodicity",
        "name": _vm.$t('plans.attributes.periodicity'),
        "data-vv-scope": index
      },
      domProps: {
        "value": (_vm.selectPlan[(index - 1)].periodicity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.selectPlan[(index - 1)].periodicity = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.periodicity'))),
        expression: "errors.has(index.toString() + '.' + $t('plans.attributes.periodicity'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('plans.attributes.periodicity'))))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xlg-1 col-lg-1-5 col-sm-12 col-xs-6"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.quantity'))
      }
    }, [_c('span', {
      staticClass: "ls-label-text col-xs-12 ls-sm-margin-bottom ls-no-padding"
    }, [_vm._v("\n                      " + _vm._s(_vm.$t('contracts.new.quantity')) + "\n                      "), _c('popover', {
      attrs: {
        "position": 'right'
      }
    }, [_c('div', {
      slot: "content"
    }, [_vm._v(_vm._s(_vm.$t('contracts.labels.quantity')))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-7 col-lg-6 col-xs-5 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectPlan[(index - 1)].quantity),
        expression: "selectPlan[(index - 1)].quantity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|decimal:0|max_quantity'),
        expression: "'required|decimal:0|max_quantity'"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "step": "1",
        "required": "",
        "name": "plans.attributes.quantity",
        "data-vv-scope": index,
        "name": _vm.$t('plans.attributes.quantity')
      },
      domProps: {
        "value": (_vm.selectPlan[(index - 1)].quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.selectPlan[(index - 1)].quantity = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.quantity'))),
        expression: "errors.has(index.toString() + '.' + $t('plans.attributes.quantity'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('plans.attributes.quantity'))))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xlg-2 col-lg-2 col-sm-12 col-xs-8 ls-no-padding-left"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.price'))
      }
    }, [_c('b', {
      staticClass: "ls-label-text ls-sm-margin-bottom"
    }, [_vm._v(_vm._s(_vm.$t('plans.new.value')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-8"
    }, [_c('money-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|onlyPositive'),
        expression: "'required|onlyPositive'"
      }],
      attrs: {
        "value": _vm.selectPlan[(index - 1)].price,
        "required": "",
        "step": "2",
        "name": _vm.$t('plans.attributes.price'),
        "data-vv-scope": index
      },
      on: {
        "updateValue": function (value) {
          _vm.selectPlan[(index - 1)].price = value
        }
      },
      model: {
        value: (_vm.selectPlan[(index - 1)].price),
        callback: function($$v) {
          _vm.selectPlan[(index - 1)].price = $$v
        },
        expression: "selectPlan[(index - 1)].price"
      }
    })], 1), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('plans.attributes.price'))),
        expression: "errors.has(index.toString() + '.' + $t('plans.attributes.price'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('plans.attributes.price'))))])])]), _vm._v(" "), _c('authorized-link', {
      attrs: {
        "tag": "create_contract_plan_entry"
      }
    }, [_c('div', {
      staticClass: "col-md-4 col-xlg-1 col-lg-1-5 col-sm-12 col-xs-6 ls-no-padding"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_quantity'))
      }
    }, [_c('span', {
      staticClass: "ls-label-text ls-sm-margin-bottom"
    }, [_vm._v(_vm._s(_vm.$t('contracts.new.discount_quantity')) + "\n                        "), _c('popover', {
      attrs: {
        "position": 'right'
      }
    }, [_c('div', {
      slot: "content"
    }, [_vm._v(_vm._s(_vm.$t('contracts.labels.discount_quantity')))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-6 col-xs-4 col-lg-5 ls-no-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectPlan[(index - 1)].contract_plan_entries[0].quantity),
        expression: "selectPlan[(index - 1)].contract_plan_entries[0].quantity"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|decimal:0|max_quantity'),
        expression: "'required|decimal:0|max_quantity'"
      }],
      attrs: {
        "type": "number",
        "required": "",
        "min": "0",
        "name": _vm.$t('contracts.new.discount_quantity'),
        "data-vv-scope": index,
        "placeholder": _vm.$t('contracts.new.discount_quantity')
      },
      domProps: {
        "value": (_vm.selectPlan[(index - 1)].contract_plan_entries[0].quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.selectPlan[(index - 1)].contract_plan_entries[0].quantity = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_quantity'))),
        expression: "errors.has(index.toString() + '.' + $t('contracts.new.discount_quantity'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('contracts.new.discount_quantity'))))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xlg-2 col-lg-2 col-sm-12 col-xs-6"
    }, [_c('label', {
      staticClass: "ls-label",
      class: {
        'ls-error': _vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_price'))
      }
    }, [_c('b', {
      staticClass: "ls-label-text ls-sm-margin-bottom"
    }, [_vm._v(_vm._s(_vm.$t('contracts.new.discount_price')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xlg-8"
    }, [_c('money-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|onlyPositive'),
        expression: "'required|onlyPositive'"
      }],
      attrs: {
        "value": _vm.selectPlan[(index - 1)].contract_plan_entries[0].price,
        "data-vv-scope": index,
        "name": _vm.$t('contracts.new.discount_price')
      },
      on: {
        "updateValue": function (value) {
          _vm.selectPlan[(index - 1)].contract_plan_entries[0].price = value
        }
      },
      model: {
        value: (_vm.selectPlan[(index - 1)].contract_plan_entries[0].price),
        callback: function($$v) {
          _vm.selectPlan[(index - 1)].contract_plan_entries[0].price = $$v
        },
        expression: "selectPlan[(index - 1)].contract_plan_entries[0].price"
      }
    })], 1), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has(index.toString() + '.' + _vm.$t('contracts.new.discount_price'))),
        expression: "errors.has(index.toString() + '.' + $t('contracts.new.discount_price'))"
      }],
      staticClass: "ls-help-message"
    }, [_vm._v(_vm._s(_vm.errors.first(index.toString() + '.' + _vm.$t('contracts.new.discount_price'))))])])])])], 1)])]) : _vm._e()])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 ls-no-padding"
  }, [_c('button', {
    staticClass: "ls-btn-primary ls-float-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('contracts.buttons.new_contract')))])])])], 2), _vm._v(" "), _c('modal-taxes', {
    attrs: {
      "linkedTaxes": _vm.selectedTaxes,
      "unlinkedTaxes": _vm.unselectedTaxes,
      "save": false
    },
    model: {
      value: (_vm.modalTaxes),
      callback: function($$v) {
        _vm.modalTaxes = $$v
      },
      expression: "modalTaxes"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-893bdda0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/contracts/New.vue
// module id = 815
// module chunks = 1